import styled from "@emotion/styled";
import { usePropertyDetailPage } from "../../context/PropertyDetailPageContext";
import { useWidth } from "@/shared/hooks/use-width.hook";
import { prepareDetailPropertyDataLogItems } from "@/src-refactor/modules/private/properties/adapters/detail/prepareDetailPropertyDataLog";
import MxDetailCard from "@rf-l1/page/details/MxDetailCard";
import MxTypography from "@rf-l1/MxTypography";
import { Grid } from "@mui/material";

const PropertyDataLog = () => {
  const width = useWidth();
  const isMobile = ["xs", "sm"].includes(width);
  const { status, dataLog } = usePropertyDetailPage();

  const properties = prepareDetailPropertyDataLogItems(dataLog, status);

  return (
    <MxDetailCard>
      <Grid container gap={1}>
        <Grid item xs={12}>
          <MxTypography color="primary.main" size={20} fontWeight={700}>
            Log de datos
          </MxTypography>
        </Grid>

        <Grid container item xs={12}>
          <Content isMobile={isMobile}>
            {properties.map(item => (
              <Grid container flexDirection="column" rowGap={1} key={item.label}>
                <Grid item xs={"auto"}>
                  <MxTypography color="grey.500" variant="overline" fontWeight={300}>
                    {item.label}
                  </MxTypography>
                </Grid>
                <Grid item xs={"auto"}>
                  <MxTypography color="grey.600" variant="overline" fontWeight={600}>
                    {item.value}
                  </MxTypography>
                </Grid>
              </Grid>
            ))}
          </Content>
        </Grid>
      </Grid>
    </MxDetailCard>
  );
};

export default PropertyDataLog;

const Content = styled.div<{ isMobile: boolean }>`
  margin-top: 10px;
  display: ${props => (props.isMobile ? "flex" : "grid")};
  flex-wrap: wrap;
  grid-template-columns: repeat(${props => (props.isMobile ? 1 : 4)}, 1fr);
  column-gap: 25px;
  row-gap: 14px;
`;
